import React, { useState } from "react";
import Dashboardnavbar from "../../layout/Dashboardnavbar";

import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast } from "../CustomFunctions";
import { useLocation } from "react-router-dom";
import Expenses from "./ExpenseTracking";
const role = sessionStorage.getItem("sitemanagement_role");


const ImprestExpenseManagement = () => {
    const location = useLocation();
    const toggleexpense = location.state !== null ? location.state?.toggleexpense : 1
    const expensetogglemanagenet = true;
    // const expensetogglemanagenet = toggleexpense;
    const emp_code = sessionStorage.getItem("emp_code")
    const email = sessionStorage.getItem("email")
    const [toggleState, setToggleState] = useState(toggleexpense);
    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return "My Imprests";
            case 2:
                return "My Expenses";
            case 3:
                return "Imprest Details";
            default:
                return "My Imprests";
        }
    };


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />


            <div className="content-tabs">
                <Expenses setToggleState={setToggleState} email={email} emp_code={emp_code} toggleState={toggleState} expensetogglemanagenet={expensetogglemanagenet} />
            </div>
        </>
    );
};

export default ImprestExpenseManagement;
